export const managerPrices = {
  page: {
    title: "Plattformpreise",
    subtitle: "Preisliste für die Tarife der Plattform",
  },
  table: {
    name: "Name",
    type: "Typ",
    price: "Preis",
    created: "Erstellt",
    edit: "Preis bearbeiten",
  },
  form: {
    title: "Preis aktualisieren",
    planName: "Tarifname",
    planType: "Tariftyp",
    annual: "Jährlich",
    monthly: "Monatlich",
    cancel: "Abbrechen",
    save: "Speichern",
  },
  toast: {
    saved: "Erfolgreich gespeichert",
    error: "Fehler bei der Anfrage",
  },
};
